import axios from 'axios'
import { AsyncCarModel, AsyncCustomerModel, AsyncPersonelModel, AsyncReservationSourceModel, AsyncVehicleGroupModel } from './ApiModels'
import { USER_GET_ALL_URL } from '../../app/pages/definition/user/Api'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
export const VEHICLE_GROUP_GET_ALL_URL = `${API_URL}api/v1/definition/vehicleGroup/all`
export const BRAND_GET_ALL_URL = `${API_URL}api/v1/definition/brand/all`
export const BRANCH_GET_ALL_URL = `${API_URL}api/v1/definition/branch/all`
export const LOCATION_GET_ALL_URL = `${API_URL}api/v1/definition/location/all`
export const VEHICLE_TYPE_GET_ALL_URL = `${API_URL}api/v1/definition/vehicleType/all`
export const RESERVATION_SOURCE_GET_ALL_URL = `${API_URL}api/v1/definition/reservationSource/all`
export const CURRENCY_GET_ALL_URL = `${API_URL}api/v1/definition/currency/all`
export const XML_TARIFF_GET_ALL_URL = `${API_URL}api/v1/definition/xmlRate/all`
export const PERSONEL_GET_ALL_URL = `${API_URL}api/v1/definition/personnel/all`
export const CASH_REGUSTERS_GET_ALL_URL = `${API_URL}api/v1/definition/cashRegister/all`
export const OFFER_GET_ALL_URL = `${API_URL}api/v1/definition/offer/all`;
export const CAR_SEARCH_URL = `${API_URL}api/v1/car/search?keyword=`
export const CUSTOMER_SEARCH_URL = `${API_URL}api/v1/customer/search?keyword=`
export const VEHICLE_GROUP_SEARCH_URL = `${API_URL}api/v1/definition/vehicleGroup/search?keyword=`
export const PERSONEL_SEARCH_URL = `${API_URL}api/v1/definition/personel/search?keyword=`
export const RESERVATION_SOURCE_SEARCH_URL = `${API_URL}api/v1/definition/reservationSource/search?keyword=`
export const VEHICLE_OWNER_GET_ALL_URL = `${API_URL}api/v1/definition/vehicleOwner/all`
export const SEGMENT_GET_ALL_URL = `${API_URL}api/v1/definition/segment/all`
 
export async function vehicleGroups() {
  const res = await axios.get(VEHICLE_GROUP_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('vehicleGroups API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.groupName || group.toString(),
  }))
}

export async function brands() {
  const res = await axios.get(BRAND_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('brands API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.name || group.toString(),
  }))
}

export async function branches() {
  const res = await axios.get(BRANCH_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('branchs API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.branchName || group.toString(),
  }))
}

export async function locations() {
  const res = await axios.get(LOCATION_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('locations API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.name || group.toString(),
  }))
}

export async function vehicleTypes() {
  const res = await axios.get(VEHICLE_TYPE_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('vehicleTypes API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.name || group.toString(),
  }))
}

export async function reservationSources() {
  const res = await axios.get(RESERVATION_SOURCE_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('Reservation Sources API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label:
      typeof group.reservationSourceName === 'string'
        ? group.reservationSourceName
        : group.name != null
          ? String(group.name)
          : String(group.id ?? index + 1),
  }))
}

export async function currencies() {
  const res = await axios.get(CURRENCY_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('Currency API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.currencyAbbreviation || group.toString(),
  }))
}

export async function tariffs() {
  const res = await axios.get(XML_TARIFF_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('XML Tariff API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.rateName || group.toString(),
  }))
}

export async function personels() {
  const res = await axios.get(PERSONEL_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('Personel API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.firstName + ' ' + group.lastName || group.toString(),
  }))
}

export async function cashReqisters() {
  const res = await axios.get(CASH_REGUSTERS_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('Cash Register API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.firstName + ' ' + group.lastName || group.toString(),
  }))
}

export async function offers() {
  const res = await axios.get(OFFER_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('Offer API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.firstName + ' ' + group.lastName || group.toString(),
  }))
}

export async function vehicleOwners() {
  const res = await axios.get(VEHICLE_OWNER_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('vehicleOwner API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.groupName || group.toString(),
  }))
}
 
export const fetchAsyncCarData = async (query: string): Promise<AsyncCarModel[]> => {
  const res = await axios.get(`${CAR_SEARCH_URL}${encodeURIComponent(query)}`);
  if (!res.data) {
    throw new Error(`Araç arama başarısız: ${res.statusText}`);
  }
  return res.data.payload;
};

export const fetchAsyncCustomerData = async (query: string): Promise<AsyncCustomerModel[]> => {
const res = await axios.get(`${CUSTOMER_SEARCH_URL}${encodeURIComponent(query)}`);
 if (!res.data) {
    throw new Error(`Müşteri arama başarısız: ${res.statusText}`);
  }
  return res.data.payload;
};

export const fetchAsyncVehicleGroupData = async (query: string): Promise<AsyncVehicleGroupModel[]> => {
  const res = await axios.get(`${VEHICLE_GROUP_SEARCH_URL}${encodeURIComponent(query)}`);
  if (!res.data) {
    throw new Error(`Araç Grubu arama başarısız: ${res.statusText}`);
  }
  return res.data.payload;
};

export const fetchAsyncPersonelData = async (query: string): Promise<AsyncPersonelModel[]> => {
  const res = await axios.get(`${PERSONEL_SEARCH_URL}${encodeURIComponent(query)}`);
 if (!res.data) {
    throw new Error(`Personel arama başarısız: ${res.statusText}`);
  }
  return res.data.payload;
};

export const fetchAsyncReservationSourceData = async (query: string): Promise<AsyncReservationSourceModel[]> => {
  const res = await axios.get(`${RESERVATION_SOURCE_SEARCH_URL}${encodeURIComponent(query)}`);
  if (!res.data) {
    throw new Error(`Rezervasyon Kaynağı arama başarısız: ${res.statusText}`);
  }
  return res.data.payload;
};

export async function segments() {
  const res = await axios.get(SEGMENT_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data

  if (!data || !Array.isArray(data.payload.content)) {
    console.error('Segment API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.name || group.toString(),
  }))
}


export async function users() {
  const res = await axios.get(USER_GET_ALL_URL, {params: {page: 0, size: 100}})
  const data = res.data
  
  if (!data || !Array.isArray(data.payload.content)) {
    console.error('Users API response content is not an array:', data.payload.content)
    return []
  }

  return data.payload.content.map((group: any, index: number) => ({
    value: group.id?.toString() || (index + 1).toString(),
    label: group.firstName + ' ' + group.lastName || group.toString(),
  }))
}

